(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kv-eye-cream-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CONF_COLORS = ['#111111', '#c6a15b', '#e8d5a3', '#f3e6d0', '#fff8ee', '#e7c1b0', '#ffffff'];
  let confettiFrame = 0;
  let confettiCanvas = null;

  const clearConfetti = () => {
    if (confettiFrame) window.cancelAnimationFrame(confettiFrame);
    confettiFrame = 0;
    if (confettiCanvas) {
      confettiCanvas.remove();
      confettiCanvas = null;
    }
  };

  const launchConfetti = () => {
    if (prefersReducedMotion() || confettiCanvas) return;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return;

    confettiCanvas = canvas;
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.position = 'fixed';
    canvas.style.inset = '0';
    canvas.style.zIndex = '10050';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    document.body.appendChild(canvas);

    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    const width = window.innerWidth;
    const height = window.innerHeight;
    canvas.width = Math.max(1, Math.floor(width * ratio));
    canvas.height = Math.max(1, Math.floor(height * ratio));
    context.setTransform(ratio, 0, 0, ratio, 0, 0);

    const pieces = [];
    const spawn = (count, fromBurst) => {
      for (let index = 0; index < count; index += 1) {
        const angle = fromBurst
          ? -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.35
          : Math.PI / 2 + (Math.random() - 0.5) * 0.8;
        const speed = fromBurst ? 7 + Math.random() * 9 : 1.5 + Math.random() * 3.2;
        pieces.push({
          x: fromBurst ? width / 2 + (Math.random() - 0.5) * 120 : Math.random() * width,
          y: fromBurst ? height * 0.46 : -20 - Math.random() * 80,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          w: 5 + Math.random() * 7,
          h: 8 + Math.random() * 10,
          color: CONF_COLORS[index % CONF_COLORS.length],
          rot: Math.random() * Math.PI,
          spin: (Math.random() - 0.5) * 0.28,
          gravity: 0.16 + Math.random() * 0.1,
          shape: index % 3
        });
      }
    };

    spawn(78, true);
    spawn(36, false);

    const started = performance.now();
    const duration = 2600;

    const tick = (now) => {
      const elapsed = now - started;
      const alpha = elapsed > duration * 0.62 ? Math.max(0, 1 - (elapsed - duration * 0.62) / (duration * 0.38)) : 1;
      context.clearRect(0, 0, width, height);

      pieces.forEach((piece) => {
        piece.vx *= 0.992;
        piece.vy = piece.vy * 0.992 + piece.gravity;
        piece.x += piece.vx;
        piece.y += piece.vy;
        piece.rot += piece.spin;
        context.save();
        context.translate(piece.x, piece.y);
        context.rotate(piece.rot);
        context.globalAlpha = alpha;
        context.fillStyle = piece.color;
        if (piece.shape === 1) {
          context.beginPath();
          context.arc(0, 0, piece.w / 2, 0, Math.PI * 2);
          context.fill();
        } else if (piece.shape === 2) {
          context.fillRect(-piece.w / 2, -piece.h / 8, piece.w, piece.h / 4);
        } else {
          context.fillRect(-piece.w / 2, -piece.h / 2, piece.w, piece.h);
        }
        context.restore();
      });

      if (elapsed < duration) {
        confettiFrame = window.requestAnimationFrame(tick);
        return;
      }

      clearConfetti();
    };

    confettiFrame = window.requestAnimationFrame(tick);
  };

  const initReveal = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.kvReady === 'true') return;

    const panel = root.querySelector('.kv-reveal__panel');
    const form = root.querySelector('.kv-reveal__form');
    const input = root.querySelector('.kv-reveal__input');
    const button = root.querySelector('.kv-reveal__button');
    const outer = root.closest('.kv-reveal-outer');

    if (!(panel instanceof HTMLElement)) return;
    if (!(form instanceof HTMLFormElement)) return;
    if (!(input instanceof HTMLInputElement)) return;
    if (!(button instanceof HTMLButtonElement)) return;

    root.dataset.kvReady = 'true';
    let closing = false;
    let submitting = false;

    const setPhase = (phase) => {
      const ready = phase === 'ready' || phase === 'loading';
      button.classList.toggle('kv-reveal__button--ready', ready);
      button.classList.toggle('kv-reveal__button--loading', phase === 'loading');
      input.classList.toggle('kv-reveal__input--ready', ready);
      button.disabled = phase !== 'ready';
      button.setAttribute('aria-busy', phase === 'loading' ? 'true' : 'false');
    };

    const syncButton = () => {
      if (closing || submitting) return;
      setPhase(input.value.trim().length === 0 ? 'idle' : 'ready');
    };

    const isShown = () => {
      if (!(outer instanceof HTMLElement)) return true;
      return window.getComputedStyle(outer).display !== 'none';
    };

    const syncPageLock = () => {
      const locked = isShown() && !root.classList.contains('kv-reveal--closed');
      document.body.classList.toggle('kv-reveal-lock', locked);
    };

    const openDialog = () => {
      if (!isShown() || root.classList.contains('kv-reveal--closed')) {
        syncPageLock();
        return;
      }
      closing = false;
      root.classList.remove('kv-reveal--closing');
      syncPageLock();
      syncButton();
      input.focus();
    };

    const closeDialog = () => {
      if (root.classList.contains('kv-reveal--closed')) {
        syncPageLock();
        return;
      }
      root.classList.remove('kv-reveal--closing');
      root.classList.add('kv-reveal--closed');
      closing = false;
      syncPageLock();
    };

    input.addEventListener('input', syncButton);
    input.addEventListener('change', syncButton);

    panel.addEventListener('animationend', (event) => {
      if (event.target !== panel) return;
      if (!root.classList.contains('kv-reveal--closing')) return;
      closeDialog();
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (closing || submitting) return;
      if (!button.classList.contains('kv-reveal__button--ready') || input.value.trim().length === 0) {
        syncButton();
        return;
      }

      submitting = true;
      input.disabled = true;
      setPhase('loading');

      window.setTimeout(() => {
        if (prefersReducedMotion()) {
          closeDialog();
          return;
        }

        launchConfetti();
        closing = true;
        root.classList.add('kv-reveal--closing');
        window.setTimeout(() => {
          if (!root.classList.contains('kv-reveal--closed')) closeDialog();
        }, 450);
      }, 1500);
    });

    syncButton();

    if (outer instanceof HTMLElement) {
      const observer = new MutationObserver(() => {
        openDialog();
      });
      observer.observe(outer, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    openDialog();
    root.kvOpenReveal = openDialog;
  };

  const revealRootFromEvent = (event) => {
    if (!(event.target instanceof Element)) return null;
    return event.target.querySelector('[data-kv-reveal]');
  };

  document.querySelectorAll('[data-kv-reveal]').forEach((root) => {
    initReveal(root);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = revealRootFromEvent(event);
    if (root) initReveal(root);
  });

  document.addEventListener('shopify:section:select', (event) => {
    const root = revealRootFromEvent(event);
    if (!(root instanceof HTMLElement)) return;
    initReveal(root);
    if (typeof root.kvOpenReveal === 'function') root.kvOpenReveal();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!revealRootFromEvent(event)) return;
    clearConfetti();
    document.body.classList.remove('kv-reveal-lock');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class GvStickyAtc {
    constructor() {
      this.el = document.querySelector('[data-sticky-add-to-cart]');
      if (!this.el) return;

      this.buttons = Array.from(this.el.querySelectorAll('[data-sticky-add-to-cart-button]'));
      this.mainButton = this.findMainButton();
      this.destroyed = false;
      this.intervals = [];

      this.scrollPercent = parseFloat(this.el.dataset.scrollPercent);
      if (isNaN(this.scrollPercent)) this.scrollPercent = 15;

      this.hideAtPercent = 95;

      this.init();
    }

    destroy() {
      this.destroyed = true;
      this.intervals.forEach((id) => clearInterval(id));
      if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onVariant) document.removeEventListener('variant:update', this._onVariant);
    }

    findMainButton() {
      const selectors = [
        '.buy-buttons-block .add-to-cart-button',
        '[data-testid="standalone-add-to-cart"]',
        'button[ref="addToCartButton"]',
        'product-form-component .add-to-cart-button',
        'form[data-type="add-to-cart-form"] button[type="submit"]',
        '.product-form button[type="submit"]',
        '.add-to-cart-button',
        'button[name="add"]'
      ];
      for (const s of selectors) {
        const b = document.querySelector(s);
        if (b) return b;
      }
      return null;
    }

    init() {
      this.setupClick();
      this.setupScroll();
      this.setupVariantImage();
      this.updateVisibility();

      const rescan = setInterval(() => {
        if (this.destroyed) return;
        const b = this.findMainButton();
        if (b !== this.mainButton) this.mainButton = b;
      }, 2000);
      this.intervals.push(rescan);
    }

    setupClick() {
      this.el.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-sticky-add-to-cart-button]');
        if (!btn) return;
        // Never submit / add to cart: only scroll to the real ATC.
        e.preventDefault();
        e.stopPropagation();
        this.scrollToMain();
      });
    }

    scrollTarget() {
      if (this.mainButton) {
        return (
          this.mainButton.closest(
            '.buy-buttons-block, product-form-component, .product-form, form[data-type="add-to-cart-form"]'
          ) || this.mainButton
        );
      }
      const sels = [
        '.buy-buttons-block',
        'product-form-component',
        '.product-form',
        'form[data-type="add-to-cart-form"]',
        'variant-picker'
      ];
      for (const s of sels) {
        const el = document.querySelector(s);
        if (el) return el;
      }
      return null;
    }

    scrollToMain() {
      const target = this.scrollTarget();
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    setupVariantImage() {
      this._onVariant = (e) => {
        const variant = e.detail && e.detail.resource;
        if (variant) this.updateThumb(variant);
      };
      document.addEventListener('variant:update', this._onVariant);
    }

    updateThumb(variant) {
      const img = this.el.querySelector('[data-sticky-thumb] img');
      if (!img || !variant || !variant.featured_media) return;
      const media = variant.featured_media;
      let base = (media.preview_image && media.preview_image.src) || media.src || null;
      if (!base) return;
      base = base.split('?')[0];
      img.src = base + '?width=160';
      if (media.alt) img.alt = media.alt;
    }

    updateVisibility() {
      if (this.destroyed || !document.contains(this.el)) return;
      const winHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      const scrollable = Math.max(docHeight - winHeight, 1);
      const percent = (window.scrollY / scrollable) * 100;
      const visible = percent >= this.scrollPercent && percent < this.hideAtPercent;
      this.el.classList.toggle('is-visible', visible);
    }

    setupScroll() {
      let ticking = false;
      this._onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.updateVisibility();
            ticking = false;
          });
          ticking = true;
        }
      };
      this._onResize = this._onScroll;
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
    }
  }

  window.GvStickyAtc = GvStickyAtc;

  function initGvStickyAtc() {
    if (window.gvStickyAtcInstance) window.gvStickyAtcInstance.destroy();
    window.gvStickyAtcInstance = new GvStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGvStickyAtc);
  } else {
    initGvStickyAtc();
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-sticky-add-to-cart]')) {
      initGvStickyAtc();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
